export default {"src":"/_next/static/media/microsoft.bc4be498.svg","height":21,"width":21};